import { Component } from '@angular/core';
import { Installation } from '../../interfaces/facilty';
import { PageInfoService } from '../../services/page-info.service';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AlarmOverview } from '../../interfaces/alarm';
import { PageInfo } from 'shared';
import { FacilityService } from '../../services/facility.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SchematicsService } from '../../services/schematics.service';
import { UserTrackingHelperService } from '../../services/user-tracking-helper.service';
import { TabComponent } from '../../components/tab/tab.component';
import { AsyncPipe } from '@angular/common';
import { PageHeaderComponent } from '../../../../../shared/src/lib/components/page-header/page-header.component';
import { TabsComponent } from '../../../../../shared/src/lib/components/tabs/tabs.component';
import { TabComponent as TabComponent_1 } from '../../../../../shared/src/lib/components/tab/tab.component';
import { PageContainerComponent } from '../../../../../shared/src/lib/components/page-container/page-container.component';
import { TabTileComponent } from '../../components/tab-tile/tab-tile.component';
import { AlarmTableComponent } from '../../components/alarms/alarm-table/alarm-table.component';
import { AlarmSettingsViewComponent } from '../../components/alarm-settings-view/alarm-settings-view.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-system-status-view-page',
    templateUrl: './system-status-view-page.component.html',
    styleUrls: ['./system-status-view-page.component.scss'],
    imports: [
    PageHeaderComponent,
    TabsComponent,
    TabComponent_1,
    TabComponent,
    PageContainerComponent,
    TabTileComponent,
    AlarmTableComponent,
    AlarmSettingsViewComponent,
    TranslateModule,
    AsyncPipe
]
})
export class SystemStatusViewPageComponent {
  public pageInfo$: Observable<PageInfo>;

  public installation$: Observable<Installation>;

  public notClearedFilter: (alarm: AlarmOverview) => boolean = (alarm) => {
    return !alarm.currentActivation.clearedTimestampEpoch;
  };

  public clearedFilter: (alarm: AlarmOverview) => boolean = (alarm) => {
    return !!alarm.currentActivation.clearedTimestampEpoch;
  };

  constructor(
    private facilityService: FacilityService,
    private schematicService: SchematicsService,
    private pageInfoService: PageInfoService,
    private router: Router,
    private route: ActivatedRoute,
    private userTrackingHelperService: UserTrackingHelperService
  ) {
    this.pageInfo$ = combineLatest([
      this.facilityService.getCurrentFacility(this.route),
      this.facilityService.getCurrentInstallation(this.route),
      this.schematicService.getFirmwareVersion(),
    ]).pipe(map(([facility, installation, firmwareVersion]) => this.pageInfoService.systemStatus(facility, installation, firmwareVersion)));
  }

  tabSelected(selectedTab: TabComponent, trackingPrefix: string) {
    this.userTrackingHelperService.trackUserAction('showAllNotificationsShown', `${trackingPrefix}Clicked`);
  }

  alarmClicked($event: any, trackingPrefix: string) {
    this.router.navigate(['alarm', $event.id], { relativeTo: this.route });
    this.userTrackingHelperService.trackUserAction(`${trackingPrefix}Clicked`, 'notificationClicked');
  }
}
